import type { ProfileBasicsValues } from 'utils/shared/playerFinder';
import { SocialLinksField } from 'components/PlayerFinder';
import ProfileFormModal from './ProfileFormModal';
import type { ProfileEditorModalProps } from './types';
import { useModalDraft } from './useModalDraft';

type SocialLinkValues = ProfileBasicsValues['socialLinks'];

interface Props extends ProfileEditorModalProps {
  defaultValues: SocialLinkValues | null;
  onSave: (values: SocialLinkValues) => Promise<boolean>;
}

export default function SocialLinksFormModal({
  isOpen,
  onClose,
  defaultValues,
  onSave,
  isSaving,
  error,
}: Props) {
  const { values, setValues, handleSave } = useModalDraft(isOpen, defaultValues, onSave, onClose);

  return (
    <ProfileFormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Social links"
      description="Turn on the networks you want players to find you on."
      onSave={handleSave}
      isSaving={isSaving}
      error={error}
    >
      {values && (
        // Remounted per open so the field's row-open memory reflects saved values.
        <SocialLinksField key={String(isOpen)} value={values} onChange={setValues} />
      )}
    </ProfileFormModal>
  );
}
